import { useApiSamplesV1SamplesListRetrieveSuspense } from 'api';
import { SampleCard, UnstyledLink } from 'features';
import { List, ListItem } from 'ui';

export const SampleList = ({ siteMaterialId }: { siteMaterialId: string }) => {
  const { data } = useApiSamplesV1SamplesListRetrieveSuspense(siteMaterialId);
  return (
    <List>
      {data.results.map((sample) => (
        <ListItem key={sample.id} sx={{ px: 0 }}>
          <UnstyledLink to={String(sample.id)} sx={{ width: '100%' }}>
            <SampleCard sample={sample} />
          </UnstyledLink>
        </ListItem>
      ))}
    </List>
  );
};
